import jpg from "../assets/images/fileManager/file/images/jpg.svg";
import gif from "../assets/images/fileManager/file/images/gif.svg";
import png from "../assets/images/fileManager/file/images/png.svg";
import psd from "../assets/images/fileManager/file/images/psd.svg";
import imageOther from "../assets/images/fileManager/file/images/other.svg";

import doc from "../assets/images/fileManager/file/text/doc.svg";
import docx from "../assets/images/fileManager/file/text/docx.svg";
import rtf from "../assets/images/fileManager/file/text/rtf.svg";
import txt from "../assets/images/fileManager/file/text/txt.svg";
import textOther from "../assets/images/fileManager/file/text/other.svg";

import html from "../assets/images/fileManager/file/web/html.svg";
import xml from "../assets/images/fileManager/file/web/xml.svg";
import css from "../assets/images/fileManager/file/web/css.svg";
import webOther from "../assets/images/fileManager/file/web/other.svg";

import pdf from "../assets/images/fileManager/file/sheet/pdf.svg";
import xls from "../assets/images/fileManager/file/sheet/xls.svg";
import xlsx from "../assets/images/fileManager/file/sheet/xlsx.svg";
import sql from "../assets/images/fileManager/file/sheet/sql.svg";
import sheetOther from "../assets/images/fileManager/file/sheet/other.svg";

import mp3 from "../assets/images/fileManager/file/audio/mp3.svg";
import wav from "../assets/images/fileManager/file/audio/wav.svg";
import flac from "../assets/images/fileManager/file/audio/flac.svg";
import audioOther from "../assets/images/fileManager/file/audio/other.svg";

import exe from "../assets/images/fileManager/file/exe/exe.svg";
import dmg from "../assets/images/fileManager/file/exe/dmg.svg";
import exeOther from "../assets/images/fileManager/file/exe/other.svg";

import ppt from "../assets/images/fileManager/file/data/ppt.svg";
import pptx from "../assets/images/fileManager/file/data/pptx.svg";
import csv from "../assets/images/fileManager/file/data/csv.svg";
import dataOther from "../assets/images/fileManager/file/data/other.svg";

import videoOther from "../assets/images/fileManager/file/video/other.svg";

import svg from "../assets/images/fileManager/file/vector/svg.svg";
import eps from "../assets/images/fileManager/file/vector/eps.svg";
import vectorOther from "../assets/images/fileManager/file/vector/other.svg";

import zip from "../assets/images/fileManager/file/compressed/zip.svg";
import rar from "../assets/images/fileManager/file/compressed/rar.svg";
import compressedOther from "../assets/images/fileManager/file/compressed/other.svg";

import systemOther from "../assets/images/fileManager/file/system/other.svg";

import fontOther from "../assets/images/fileManager/file/font/other.svg";

import other from "../assets/images/fileManager/file/other.svg";

enum ResourceTypeEnum {
    IMAGE,
    TEXT,
    WEB,
    SHEET,
    AUDIO,
    EXE,
    DATA,
    VIDEO,
    VECTOR,
    COMPRESSED,
    SYSTEM,
    FONT
}

interface ResourceFormatsType {
    type: ResourceTypeEnum;
    specialFormats: { format: string; icon: string }[];
    otherFormats: string[];
    defaultIcon: string;
}

const resourceFormats: ResourceFormatsType[] = [
    {
        type: ResourceTypeEnum.IMAGE,
        defaultIcon: imageOther,
        otherFormats: [".jpeg", ".jfif", ".pjpeg", ".pjp", ".webp", ".ico", ".ai", ".bmp", ".ps", ".tif", ".heic"],
        specialFormats: [
            { format: ".jpg", icon: jpg },
            { format: ".heic", icon: jpg },
            { format: ".gif", icon: gif },
            { format: ".png", icon: png },
            { format: ".psd", icon: psd }
        ]
    },
    {
        type: ResourceTypeEnum.TEXT,
        defaultIcon: textOther,
        otherFormats: [".tar", ".tex", ".iso", ".log", ".key"],
        specialFormats: [
            { format: ".doc", icon: doc },
            { format: ".docx", icon: docx },
            { format: ".rtf", icon: rtf },
            { format: ".txt", icon: txt }
        ]
    },
    {
        type: ResourceTypeEnum.WEB,
        defaultIcon: webOther,
        otherFormats: [
            ".json",
            ".py",
            ".js",
            ".jsx",
            ".ts",
            ".tsx",
            ".c",
            ".cc",
            ".h",
            ".cpp",
            ".hpp",
            ".java",
            ".php",
            ".dev",
            ".swift",
            ".sh",
            ".yml",
            ".yaml",
            ".xaml"
        ],
        specialFormats: [
            { format: ".xml", icon: xml },
            { format: ".html", icon: html },
            { format: ".css", icon: css }
        ]
    },
    {
        type: ResourceTypeEnum.SHEET,
        defaultIcon: sheetOther,
        otherFormats: [".pmd"],
        specialFormats: [
            { format: ".pdf", icon: pdf },
            { format: ".xls", icon: xls },
            { format: ".xlsx", icon: xlsx },
            { format: ".sql", icon: sql }
        ]
    },
    {
        type: ResourceTypeEnum.AUDIO,
        defaultIcon: audioOther,
        otherFormats: [".ogg"],
        specialFormats: [
            { format: ".mp3", icon: mp3 },
            { format: ".wav", icon: wav },
            { format: ".flac", icon: flac }
        ]
    },
    {
        type: ResourceTypeEnum.EXE,
        defaultIcon: exeOther,
        otherFormats: [".apk", ".deb", ".bat", ".cgi", ".com", ".jar", ".msi", ".wsf"],
        specialFormats: [
            { format: ".exe", icon: exe },
            { format: ".dmg", icon: dmg }
        ]
    },
    {
        type: ResourceTypeEnum.DATA,
        defaultIcon: dataOther,
        otherFormats: [".bin"],
        specialFormats: [
            { format: ".ppt", icon: ppt },
            { format: ".pptx", icon: pptx },
            { format: ".csv", icon: csv }
        ]
    },
    {
        type: ResourceTypeEnum.VIDEO,
        defaultIcon: videoOther,
        otherFormats: [".avi", ".mp4", ".wmv", ".3gp", ".mkv", ".m4a", ".wmv", ".flv", ".webm", ".m4v"],
        specialFormats: []
    },
    {
        type: ResourceTypeEnum.VECTOR,
        defaultIcon: vectorOther,
        otherFormats: [".cdr"],
        specialFormats: [
            { format: ".svg", icon: svg },
            { format: ".eps", icon: eps }
        ]
    },
    {
        type: ResourceTypeEnum.COMPRESSED,
        defaultIcon: compressedOther,
        otherFormats: [".7z", ".tar.gz", ".arj", ".deb", ".pkg"],
        specialFormats: [
            { format: ".zip", icon: zip },
            { format: ".rar", icon: rar }
        ]
    },
    {
        type: ResourceTypeEnum.SYSTEM,
        defaultIcon: systemOther,
        otherFormats: [".bak", ".cab", ".cfg", ".cpl", ".cur", ".dll", ".dmp", ".drv", ".icns", ".ini", ".lnk", ".msi", ".sys", ".tmp"],
        specialFormats: []
    },
    {
        type: ResourceTypeEnum.FONT,
        defaultIcon: fontOther,
        otherFormats: [".fnt", ".fon", ".otf", ".ttf"],
        specialFormats: []
    }
];

const setResourceIcon = (format: string) => {
    const index = resourceFormats.findIndex((item) =>
        [...item.otherFormats, ...item.specialFormats.map((special) => special.format)].includes(format)
    );
    if (index > -1) {
        const type = resourceFormats[index];
        const item = type.specialFormats.find((special) => special.format === format);
        if (item) {
            return item.icon;
        } else {
            return type.defaultIcon;
        }
    } else {
        return other;
    }
};

export { setResourceIcon };
